import { withHandlers } from 'recompose'
import SelectedFilter from './SelectedFilter'

export default withHandlers({
  handleRemove: ({ onFilterRemove, ...props }) => () => onFilterRemove(props)
})(SelectedFilter)
